import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const createDistrict = createAsyncThunk('createDistrict', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/district',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteDistrict = createAsyncThunk('deleteDistrict', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/district?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editDistrict = createAsyncThunk('editDistrict', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/district',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})